import ThemedComponent from '../../hoc/ThemedComponent';

import { default as StatisticsViewDefault } from './Statistics/View';
import { default as StatisticsView3 } from '../../themes/3/components/Statistics/Statistics';
import { default as StatisticsView4 } from '../../themes/4/components/Statistics/Statistics';

import { default as StatisticsFiltersViewDefault } from './StatisticsFilters/View';
import { default as StatisticsFiltersView3 } from '../../themes/3/components/Statistics/StatisticsFilters';
import { default as StatisticsFiltersView4 } from '@themes/4/components/Statistics/StatisticsFilters';

import { default as StatisticsTableFieldDefault } from './StatisticsTableField';
import { default as StatisticsTableField3 } from '../../themes/3/components/Statistics/StatisticsTableField';

import { default as StatisticsConversionsTableViewDefault } from './StatisticsConversionsTable/View';
import { default as StatisticsConversionsTableView3 } from '../../themes/3/components/Statistics/StatisticsConversionsTable';

import { default as StatisticsSubIdFilterViewDefault } from './StatisticsSubIdFilter/View';
import { default as StatisticsSubIdFilterView3 } from '../../themes/3/components/Statistics/StatisticsSubIdsFilter';

import { default as StatisticsSubIdsFiltersViewDefault } from './StatisticsSubIdsFilters/View';
import { default as StatisticsSubIdsFiltersView3 } from '../../themes/3/components/Statistics/StatisticsSubIdsFilters';
import { default as StatisticsSubIdsFiltersView4 } from '@themes/4/components/Statistics/StatisticsSubIdsFilters';

import { default as StatisticsExportViewDefault } from './StatisticsExport/View';
import { default as StatisticsExportView3 } from '../../themes/3/components/Statistics/StatisticsExport';

import { default as StatisticsDateFilterViewDefault } from './StatisticsDateFilter/View';
import { default as StatisticsDateFilterView3 } from '../../themes/3/components/Statistics/StatisticsDateFilter';

const ThemedStatistics = {
  default: StatisticsViewDefault,
  // 3: StatisticsView3,
  // 4: StatisticsView4,
};

const ThemedStatisticsFilters = {
  default: StatisticsFiltersViewDefault,
  // 3: StatisticsFiltersView3,
  // 4: StatisticsFiltersView4,
};

const ThemedStatisticsTableField = {
  default: StatisticsTableFieldDefault,
  // 3: StatisticsTableField3,
};

const ThemedStatisticsConversionsTable = {
  default: StatisticsConversionsTableViewDefault,
  // 3: StatisticsConversionsTableView3,
};

const ThemedStatisticsSubIdFilter = {
  default: StatisticsSubIdFilterViewDefault,
  // 3: StatisticsSubIdFilterView3,
};

const ThemedStatisticsSubIdsFilters = {
  default: StatisticsSubIdsFiltersViewDefault,
  // 3: StatisticsSubIdsFiltersView3,
  // 4: StatisticsSubIdsFiltersView4,
};

const ThemedStatisticsExport = {
  default: StatisticsExportViewDefault,
  // 3: StatisticsExportView3,
};

const ThemedStatisticsDateFilter = {
  default: StatisticsDateFilterViewDefault,
  // 3: StatisticsDateFilterView3,
};

export const StatisticsView = ThemedComponent(ThemedStatistics);
export const StatisticsFiltersView = ThemedComponent(ThemedStatisticsFilters);
export const StatisticsTableField = ThemedComponent(ThemedStatisticsTableField);
export const StatisticsConversionsTableView = ThemedComponent(ThemedStatisticsConversionsTable);
export const StatisticsSubIdFilterView = ThemedComponent(ThemedStatisticsSubIdFilter);
export const StatisticsSubIdsFiltersView = ThemedComponent(ThemedStatisticsSubIdsFilters);
export const StatisticsExportView = ThemedComponent(ThemedStatisticsExport);
export const StatisticsDateFilterView = ThemedComponent(ThemedStatisticsDateFilter);
